var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('enterpriseHead',{attrs:{"tabArrShow":_vm.tabArrShow}}),_c('router-view'),_c('bottomContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }